import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '14.0901 3.0002'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M27.3101 0.650146C27.3101 0.650146 22.8901 1.98016 14.3501 1.98016C5.81013 1.98016 0.870117 0.650146 0.870117 0.650146C0.870117 0.650146 5.46014 5.35016 14.0801 5.35016C22.7101 5.36016 27.3101 0.650146 27.3101 0.650146Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
  )
}
